import { Navigate, useLocation } from 'react-router-dom';
import storage from '../Assets/js/Global';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const loginObj = storage.get('loginObj');

    const isAuthenticated = loginObj && loginObj.userKey;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;